import Chart from 'react-apexcharts';

function TornadoBarChart({
  title = '',
  categories = [],
  series = [],
  min,
  max,
  width = 330,
  height = 230,
  suffix = '',
  dataLabelFormatter = (val) => {
    if (val === 0) return '';
    return `${Math.abs(val)}`;
  },
  paddingRight = 20,
  paddingLeft = 20,
}) {
  const allValues = series.flatMap((x) => x.data?.flatMap((y) => (Array.isArray(y.y) ? y.y : [y.y])));
  const minValue = typeof min === 'number' ? min : Math.min(...allValues) - 20;
  const maxValue = typeof max === 'number' ? max : Math.max(...allValues) + 20;

  const options = {
    title: {
      text: title,
    },
    chart: {
      animations: { enabled: false },
      stacked: true,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top',
          hideOverflowingLabels: false,
        },
      },
    },
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: {
        fontSize: '10px',
        fontWeight: 'normal',
        colors: ['#000'],
      },
      formatter: dataLabelFormatter,
      offsetX: 5,
    },
    xaxis: {
      categories,
      min: minValue,
      max: maxValue,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
      tickPlacement: 'between',
    },
    yaxis: {
      axisTicks: { show: false },
      title: { text: '' },
      tooltip: { enabled: false },
      labels: {
        offsetX: -20,
        style: {
          fontSize: '10px',
          fontWeight: 'normal',
        },
      },
    },
    tooltip: {
      y: {
        formatter(val) {
          return `${Math.abs(val).toFixed(0)}${suffix}`;
        },
      },
    },
    grid: {
      padding: {
        right: paddingRight,
        left: paddingLeft,
      },
    },
    annotations: {
      xaxis: [
        {
          x: 0,
          borderColor: '#000',
          strokeDashArray: 4,
          label: {
            text: '',
            style: {
              color: '#000',
              background: '#fff',
            },
          },
        },
      ],
    },
  };

  return <Chart options={options} series={series} type="bar" width={width} height={height} />;
}

export default TornadoBarChart;
